import { Routes, Route } from 'react-router-dom';
import RegisterPage from './AUTH/RegisterPage';
import LoginPage from './AUTH/LoginPage';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import GoogleCallback from './AUTH/GoogleCallback';
import NotFound from './pages/Notfound';
import { ScrollToTop } from './components/ScrollToTop';
import ProfilePage from './pages/Profile/ProfilePage';
import MyOrders from './SHOP/user/MyOrders';
import ProductDetailsPage from './SHOP/tools/ProductDetailsPage';
import MyHtmlJsonConverter from './MY_COMPONENTS/HtmlJson/MyHtmlJsonConverter';
import TipTapWithJsonPreview from './MY_COMPONENTS/HtmlJson/TipTapWithJsonPreview';
import ProfilesPage from './PROFILES/ProfilesPage';
import ProfileDetails from './PROFILES/ProfileDetails';
import { ForgotPassword } from './AUTH/ForgotPassword';
import { ChangePassword } from './AUTH/ChangePassword';
import Listings from './LISTINGS/Listings';
import ListingsPage from './LISTINGS/ListingsPage';
import ListingDetails from './LISTINGS/ListingDetails';
import ListingDetailsPage from './LISTINGS/ListingDetailsPage';
import AdminManageListings from './LISTINGS/AdminManageListings';
import AdminManageProfiles from './PROFILES/AdminManageProfiles';
import ClockPage from './MY_COMPONENTS/DynamicClock/ClockPage';
import ScraperPage from './SCRAPER/ScraperPage';
import MvNews from './SCRAPER/MvNews';
import GazetteAnnouncementsPage from './SCRAPER/GazetteAnnouncements';
import GazetteAnnouncementDetail from './SCRAPER/GazetteAnnouncementDetail';
import MvStocks from './SCRAPER/MvStocks';
import QuizPage from './QUIZ/QuizPage';
import SettingsPage from './pages/SettingsPage';
import MobileAppLandingPage from './pages/MobileAppLandingPage';
import ContactForm from './pages/ContactForm';
import SupportPage from './pages/SupportPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import QuizHome from './QUIZ/QuizHome';
import Templates from './Templates/Templates';
import HotelFront from './Templates/HotelFront/HotelFront';
import { Home, RoomDetails } from './Templates/HotelFront/pages';
import Contact from './Templates/HotelFront/pages/Contact';
import { Rooms } from './Templates/HotelFront/components';
import IslandFront from './Templates/IslandFront/IslandFront';
import ShopFront from './Templates/ShopFront/ShopFront';
import MyShopFront from './Templates/ShopFront/MyShopFront';
import RouteFront from './Templates/RouteFront/RouteFront';
import QuranQuiz from './Templates/QuranQuiz/QuranQuiz';
import MyQuizApp from './Templates/QuizApp/MyQuizApp';
import MyApp from './Templates/MyApp/MyApp';
import IulaanApp from './Templates/IulaanFront/IulaanApp';


function App() {
  return (
    <div id="dialog-root" className="bg-background text-text-dark min-h-screen">
      <ScrollToTop />
      <Routes>

        {/* Public */}
        <Route path="/" element={<MainLayout><HomePage /></MainLayout>} />
        {/* <Route path="/terms" element={<MainLayout><TermsAndConditionsPage /></MainLayout>} /> */}
        <Route path="/myhtmljson" element={<MainLayout><MyHtmlJsonConverter /></MainLayout>} />
        <Route path="/myhtmldesigner" element={<MainLayout><TipTapWithJsonPreview /></MainLayout>} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<MainLayout><ForgotPassword /></MainLayout>} />
        <Route path="/change-password" element={<MainLayout><ChangePassword /></MainLayout>} />
        <Route path="/register" element={<MainLayout><RegisterPage /></MainLayout>} />
        <Route path="/auth/google/callback" element={<GoogleCallback />} />
        <Route path="/home" element={<MainLayout><HomePage /></MainLayout>} />
        <Route path="/clock" element={<ClockPage />} />
        <Route path="/quiz" element={<QuizHome />} />

        <Route path="/templates" element={<Templates />} />
        <Route path="/templates/hotelfront" element={<HotelFront />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="room/:id" element={<RoomDetails />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        <Route path="/templates/islandfront" element={<IslandFront />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        <Route path="/templates/shopfront" element={<MyShopFront />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="/templates/routefront" element={<RouteFront />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        
        <Route path="/templates/quranquiz" element={<QuranQuiz />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="/templates/quizapp" element={<MyQuizApp />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>

        <Route path="/templates/myapp" element={<MyApp />}>
          <Route index element={<Home />} />
          <Route path="rooms" element={<Rooms />} />
          <Route path="contact" element={<Contact />} />
        </Route>
        <Route path="/templates/iulaanfront" element={<IulaanApp />}>
          <Route index element={<Home />} />
        </Route>

        <Route path="/profiles" element={<MainLayout><ProfilesPage /></MainLayout>} />
        <Route path="/listings" element={<MainLayout><ListingsPage /></MainLayout>} />
        <Route path="/scraper" element={<MainLayout><ScraperPage /></MainLayout>} />
        <Route path="/mvnews" element={<MainLayout><MvNews /></MainLayout>} />
        <Route path="/mvstocks" element={<MainLayout><MvStocks /></MainLayout>} />
        <Route path="/mviulaan" element={<MainLayout><GazetteAnnouncementsPage /></MainLayout>} />
        <Route path="/mviulaan/:id" element={<MainLayout><GazetteAnnouncementDetail /></MainLayout>} />
        <Route path="/listingdetails/:id" element={<MainLayout><ListingDetailsPage /></MainLayout>} />
        <Route path="/adminmanagelistings" element={<MainLayout><AdminManageListings /></MainLayout>} />
        <Route path="/adminmanageprofiles" element={<MainLayout><AdminManageProfiles /></MainLayout>} />
        <Route path="/profile/:userId" element={<MainLayout><ProfileDetails /></MainLayout>} />
        <Route path="/shop/variant/:id" element={<MainLayout><ProductDetailsPage /></MainLayout>} />
        <Route path="/myorders" element={<MainLayout><MyOrders /></MainLayout>} />
        <Route path="/settings" element={<MainLayout><SettingsPage /></MainLayout>} />
        <Route path="/mobileapplanding" element={<MobileAppLandingPage />} />
        <Route path="/contact" element={<ContactForm />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        
        
        <Route path="/myprofile" element={<MainLayout><ProfilePage /></MainLayout>}/>

        <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />

      </Routes>
    </div>
  );
}

export default App;
